import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { AccountModal, ProModal } from '@/lazy-load-components';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import { ModalHelper } from '@/helpers/modal-helper';
import { isProWebCountry, saveLastProView } from '@/helpers/pro-web-helper';
import { useLanguageStore, useTitleDetailsStore } from '@/helpers/composables/useStores';

import { SnowplowTitleContextGraphql } from '@/helpers/tracking/providers/snowplow-contexts';

import { useExperiment } from '@/libraries/experiment';
import { useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'MrrBannerExp',
  props: {
    adPosition: null
  },
  setup(__props: any) {

const props = __props as { adPosition: string };



const router = useRouter();
const { webLocale } = useLanguageStore();
const { titleContext } = useTitleDetailsStore();

const { activeVariantWithControlGroup: mrrBannerExpVariant, trackEvent } = useExperiment('MRR_BANNER_EXP');

const mrrBannerExpImg = computed(() => {
	if (!['under_buybox', 'under_detail_info', 'bottom_page'].includes(props.adPosition)) return;
	return `${ASSETS_DIR}/img/experiments/mrr-banner-exp/${props.adPosition}-${mrrBannerExpVariant.value}` ?? undefined;
});

const variantDeeplinks = computed(() => {
	return {
		control: '',
		variant_1: '',
		variant_2: '',
		variant_3:
			'https://justwatch.onelink.me/7jXE?af_xp=custom&pid=BannerV3Mob&c=July_2025_Experiment&af_dp=justwatch%3A%2F%2F',
		variant_4:
			'https://justwatch.onelink.me/7jXE?af_xp=custom&pid=BannerV4Mob&c=July_2025_Experiment&af_dp=justwatch%3A%2F%2F',
		variant_5:
			'https://justwatch.onelink.me/7jXE?af_xp=custom&pid=BannerV5Mob&c=July_2025_Experiment&af_dp=justwatch%3A%2F%2F',
		variant_6:
			'https://justwatch.onelink.me/7jXE?af_xp=custom&pid=BannerV6Mob&c=July_2025_Experiment&af_dp=justwatch%3A%2F%2F',
	};
});

const isNonClickable = computed(() => {
	return ['variant_3', 'variant_4', 'variant_5', 'variant_6'].includes(mrrBannerExpVariant.value ?? '');
});

const trackingLabel = computed(() => {
	if (mrrBannerExpVariant.value === 'variant_1') return 'watch_now';
	if (mrrBannerExpVariant.value === 'variant_2') return 'get_jw_pro';
	if (['variant_3', 'variant_4', 'variant_5', 'variant_6'].includes(mrrBannerExpVariant.value ?? ''))
		return 'app_download';
	return '';
});

const onVisibleCallback = {
	callback: (isVisible: boolean, entry: IntersectionObserverEntry) => {
		const contexts = [];
		if (titleContext.value) {
			const { titleId, objectType, seasonNumber, episodeNumber, contentType } = titleContext.value;
			contexts.push(
				new SnowplowTitleContextGraphql(titleId, objectType, seasonNumber, episodeNumber, contentType)
			);
		}

		if (isVisible) {
			trackEvent({
				action: 'impression',
				label: trackingLabel.value,
				property: 'mrr',
				contexts,
			});
		}
	},
};

function mrrBannerExpAction() {
	trackEvent({
		action: 'click',
		label: trackingLabel.value,
		property: 'mrr',
		contexts: [titleContext.value],
	});

	if (mrrBannerExpVariant.value === 'variant_1') {
		router.push({ name: 'app.titles.popular.provider', params: { provider: 'justwatchtv' } });
		return;
	} else if (mrrBannerExpVariant.value === 'variant_2') {
		ModalHelper.openModal(
			ProModal,
			{},
			{
				cssClass: 'pro-jw-pro-modal',
			},
			'MrrBanner',
			true
		);
		return;
	} else {
		window.location.href = variantDeeplinks.value[mrrBannerExpVariant.value ?? 'variant_1'];
		return;
	}
}

function openModal() {
	const location = 'RemoveAds';
	if (isProWebCountry(webLocale.value)) {
		ModalHelper.openModal(ProModal, {}, {}, location, true);
		saveLastProView(location);
	} else {
		ModalHelper.openModal(AccountModal, { closable: true }, { cssClass: 'account-modal' }, 'AdUnit');
	}
}

return { __sfc: true,props, router, webLocale, titleContext, mrrBannerExpVariant, trackEvent, mrrBannerExpImg, variantDeeplinks, isNonClickable, trackingLabel, onVisibleCallback, mrrBannerExpAction, openModal, faTimes }
}

})